import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import HTopbar from '../../hooks/HomeTopBar';
function RPassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      alert('Passwords do not match!');
      return;
    }
    // Handle password reset logic
    console.log('Password reset:', password);
  };

  return (
    <div className="d-flex align-items-center justify-content-center vh-100 bg-white">
        <HTopbar/>
      <div className="p-5 shadow rounded" style={{ maxWidth: '400px', width: '100%' }}>
        <h1 className="text-center fw-bold mb-2" style={{ color: '#222' }}>MATCH <span className="text-warning">UP</span></h1>
        <p className="text-center mb-4 fs-5 text-muted">Reset Password to Access Matchmaking</p>

        <form onSubmit={handleSubmit}>
          <div className="mb-3 position-relative">
            <input
              type={showPassword ? 'text' : 'password'}
              className="form-control"
              placeholder="Enter New Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="mb-3 position-relative">
            <input
              type={showPassword ? 'text' : 'password'}
              className="form-control"
              placeholder="Re-Enter New Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          <div className="form-check mb-4">
            <input
              type="checkbox"
              className="form-check-input"
              id="showPassword"
              onChange={() => setShowPassword(!showPassword)}
            />
            <label className="form-check-label" htmlFor="showPassword">
              Show Passwords
            </label>
          </div>

          <button type="submit" className="btn btn-dark w-100 mb-2">Continue</button>
          <button type="button" className="btn btn-outline-secondary w-100">Cancel</button>
        </form>
      </div>
    </div>
  );
}

export default RPassword;
